import React from 'react'
import { Form, Row, Col, Button } from 'react-bootstrap'

// definitions
import { CustomMappings, CustomMappingsProps } from './CustomMappings'
import { ProductMapping, ProductMappingProps } from './ProductMapping'
import { Error } from '../settings'

interface ProductSettingsProps extends ProductMappingProps, CustomMappingsProps {
	handleOrgUpdate: (stripeOrgID: string, name: string, value: string) => void
	errors: Error[]
}

const ProductSettings = (props: ProductSettingsProps) => {
	return (
		<>
			<Form.Group as={Row} className="mb-5">
				<Col sm="2">
					<Form.Label className="mr-3">Map Stripe products to</Form.Label>
				</Col>
				<Col className="d-flex justify-content-start">
					<Button
						id={`${props.stripeOrgID}-mapping-type-account`}
						variant="outline-secondary"
						className={'option-button ' + (props.orgMapping?.stripeOrgAccountXeroOrgMappingType === 'Account' ? 'active' : '')}
						onClick={() => props.handleOrgUpdate(props.stripeOrgID!, 'stripeOrgAccountXeroOrgMappingType', 'Account')}
					>
						Xero Accounts
					</Button>
					<Button
						id={`${props.stripeOrgID}-mapping-type-item`}
						variant="outline-secondary"
						className={'option-button ' + (props.orgMapping?.stripeOrgAccountXeroOrgMappingType === 'Item' ? 'active' : '')}
						onClick={() => props.handleOrgUpdate(props.stripeOrgID!, 'stripeOrgAccountXeroOrgMappingType', 'Item')}
					>
						Xero Products
					</Button>
					<Button
						id={`${props.stripeOrgID}-mapping-type-custom`}
						variant="outline-secondary"
						className={'option-button ' + (props.orgMapping?.stripeOrgAccountXeroOrgMappingType === 'Custom' ? 'active' : '')}
						onClick={() => props.handleOrgUpdate(props.stripeOrgID!, 'stripeOrgAccountXeroOrgMappingType', 'Custom')}
					>
						Advanced mapping
					</Button>
				</Col>
			</Form.Group>
			{props.orgMapping?.stripeOrgAccountXeroOrgMappingType === 'Custom' ? (
				<CustomMappings
					stripeOrgID={props.stripeOrgID!}
					orgMapping={props.orgMapping!}
					types={['Account', 'Item', null]}
					customMappings={props.orgMapping!.customMappings!}
					mappedXeroOrg={props.mappedXeroOrg}
					stripeMappingTypes={props.stripeMappingTypes}
					stripeObjectMaps={props.stripeObjectMaps}
					stripeObjectMapSelectOptions={props.stripeObjectMapSelectOptions}
					handleCustomMappingUpdate={props.handleCustomMappingUpdate}
					handleSettingsUpdate={props.handleSettingsUpdate}
				/>
			) : (
				<ProductMapping
					stripeProducts={props.stripeProducts}
					orgMapping={props.orgMapping!}
					mappedXeroOrg={props.mappedXeroOrg}
					stripeOrgID={props.stripeOrgID!}
					handleProductUpdate={props.handleProductUpdate}
					handleProductAdd={props.handleProductAdd}
					handleApplyToAllProducts={props.handleApplyToAllProducts}
					errors={props.errors}
				/>
			)}
		</>
	)
}

export { ProductSettings }
export type { ProductSettingsProps }
